import request from "@/utils/request";

/**
 * @typedef Material
 * @prop {number} id
 * @prop {string} name
 */

/**
 * @param {{limit?: number, offset?: number}} params
 * @returns {{materials: Material[]}}
 */
export function getMaterials(params) {
  return request({
    url: "/api/admin/materials/",
    method: "get",
    params,
  });
}

/**
 * @param {{name: string}} data
 * @returns {Material}
 */
export function createMaterial(data) {
  return request({
    url: "/api/admin/materials/",
    method: "post",
    data,
  });
}

/**
 * @param {number} materialId
 * @returns {Material}
 */
export function getMaterial(materialId) {
  return request({
    url: `/api/admin/materials/${materialId}/`,
    method: "get",
  });
}

/**
 * @param {number} materialId
 */
export function deleteMaterial(materialId) {
  return request({
    url: `/api/admin/materials/${materialId}/`,
    method: "delete",
  });
}

/**
 * @param {number} materialId
 * @param {{name: string}} data
 * @returns {Material}
 */
export function updateMaterial(materialId, data) {
  return request({
    url: `/api/admin/materials/${materialId}/`,
    method: "patch",
    data,
  });
}
